import { Publisher } from "../types";

/**
 * Creates Baana Publisher structured data
 * This is a shared builder used in Article structured data
 */
export const createBaanaPublisher = (): Publisher => ({
  "@type": "Organization",
  name: "Baana",
  logo: {
    "@type": "ImageObject",
    url:
      import.meta.env.VITE_BAANA_LOGO_HERO_URL ??
      "https://baana-frontpage-prod.s3.eu-west-1.amazonaws.com/images/Baana_by_nettiauto_hero.webp"
  }
});
